module.exports = __webpack_public_path__ + "static/media/integration.56e308b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/integration.svg
// module id = 63
// module chunks = 0